(function(){

  zfrespond.views.CameraHelpModalView = Backbone.View.extend({

    className: "camera-help-modal-view",

    events: {
      'click .action-toggle-body': 'handleToggleBody',
      'click .action-close': 'handleClose',
    },

    template: ZFRESPOND_JST.camera_help_modal,

    initialize: function(options) {
      options = options || {};
      this.mode = options.mode;
    },

    render: function() {

      this.$el.html(this.template({ 
        thisUrl: window.location.href

      }));

      if (this.mode === 'desktop') {
        this.$el.addClass('desktop');

      } else if (this.mode === 'desktop') {
        this.$el.addClass('desktop');

      } else if (this.mode === 'mobile') {
        this.$el.addClass('mobile');
      }

      this.$('.help-item-body').hide();

      return this;
    },


    handleToggleBody: function(e) {
      var $helpItemHeader = $(e.currentTarget);
      var $helpItemBody = $helpItemHeader.siblings('.help-item-body');

      if ($helpItemBody.is(':visible')) {
        $helpItemBody.slideUp()
          .closest('.help-item-container').removeClass('opened');

      } else {
        $helpItemBody.slideDown().closest('.help-item-container')
          .addClass('opened');
        this.$('.help-item-body')
          .not($helpItemBody).slideUp()
          .closest('.help-item-container').removeClass('opened');

      }
    },

    handleClose: function() {
      this.remove();
    }

  }, {

    show : function(options) {
      var modal = new zfrespond.views.CameraHelpModalView(options);
      $('body').append(modal.render().$el);
      // modal.focusOnInput();
      return modal;
    }

  });

}());